import { render, staticRenderFns } from "./BusinessCard.vue?vue&type=template&id=d8397000&"
import script from "./BusinessCard.vue?vue&type=script&lang=js&"
export * from "./BusinessCard.vue?vue&type=script&lang=js&"
import style0 from "./BusinessCard.vue?vue&type=style&index=0&id=d8397000&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports